import { useTheme } from '@mui/material';
import {
  ACCOUNT_TYPE_OBJECT,
  BANK_LIST_OBJECT,
  formatCNPJ,
  formatCPF,
} from 'app/helpers';
import { Heading4, TextM } from 'app/components';
import { PixType } from 'modules/customer/context/CustomerProvider/customer.interfaces';
import {
  ReviewSimulationBox,
  ReviewSimulationPreviewItem,
  ReviewSimulationPreviewItems,
  ReviewStepBox,
} from '../styles';
import { ReviewStepSimulationDivider } from './ReviewStepSimulationDivider';

interface ReviewStepBorrowerAccountProps {
  borrowerData: {
    full_name?: string;
    legal_name?: string;
    taxpayer_id?: string;
    pix?: {
      key: string;
      key_type: string;
    };
    external_bank_account?: {
      ispb_code?: string;
      bank_account_type?: string;
      bank_branch?: string;
      bank_account?: string;
      bank_account_digit?: string;
    };
  } | null;
  borrowerType: 'PERSON' | 'COMPANY';
  getFormatedPix: (pixKey?: string, pixType?: PixType) => string;
}

const ReviewStepBorrowerAccount = ({
  borrowerData,
  borrowerType,
  getFormatedPix,
}: ReviewStepBorrowerAccountProps) => {
  const theme = useTheme();
  const isPerson = borrowerType === 'PERSON';

  if (!borrowerData?.external_bank_account?.bank_account) {
    return null;
  }

  return (
    <ReviewStepBox marginTop="0px" marginBottom="16px">
      <Heading4
        style={{
          color: theme.palette.brand.secondary.base,
        }}
      >
        Conta do Tomador
      </Heading4>
      <ReviewSimulationBox>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Nome
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {isPerson ? borrowerData?.full_name : borrowerData?.legal_name}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                {borrowerType === 'PERSON' ? 'CPF' : 'CNPJ'}
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {borrowerType === 'PERSON'
                  ? formatCPF(borrowerData?.taxpayer_id || '-')
                  : formatCNPJ(borrowerData?.taxpayer_id || '-')}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Banco
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {borrowerData?.external_bank_account?.ispb_code
                  ? BANK_LIST_OBJECT[
                      borrowerData.external_bank_account.ispb_code
                    ]
                    ? `${
                        BANK_LIST_OBJECT[
                          borrowerData.external_bank_account.ispb_code
                        ]
                      } (${borrowerData.external_bank_account.ispb_code})`
                    : borrowerData.external_bank_account.ispb_code
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Tipo
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {borrowerData?.external_bank_account?.bank_account_type
                  ? ACCOUNT_TYPE_OBJECT[
                      borrowerData.external_bank_account.bank_account_type
                    ] ?? '-'
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Chave Pix
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {borrowerData?.pix
                  ? getFormatedPix(
                      borrowerData.pix.key,
                      borrowerData.pix.key_type as PixType,
                    )
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Agência
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {borrowerData?.external_bank_account?.bank_branch || '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Conta
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {borrowerData?.external_bank_account?.bank_account
                  ? `${borrowerData.external_bank_account.bank_account}-${borrowerData.external_bank_account.bank_account_digit}`
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
      </ReviewSimulationBox>
    </ReviewStepBox>
  );
};

export default ReviewStepBorrowerAccount;
